// extracted by mini-css-extract-plugin
export default {"companyContainer":"NN-z","companyImage":"ON-z","container":"PN-z","heading":"QN-z","darkText":"RN-z","smallHeading":"SN-z","darkBackground":"TN-z","whiteBackground":"UN-z"};